// extracted by mini-css-extract-plugin
module.exports = {"featured":"styles_featured__Bssns"};